import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { agentAuthService } from '../services/agentAuthService';

/**
 * Protected route component for Abidjan agents
 * Ensures only authenticated AGENT_ABJ users can access agent routes
 */
export function ProtectedAgentRoute({ children }) {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    checkAgentAuth();
  }, []);

  const checkAgentAuth = async () => {
    try {
      const session = await agentAuthService?.getSession();
      setIsAuthenticated(!!session);
    } catch (error) {
      console.error('Error checking agent auth:', error);
      setIsAuthenticated(false);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Vérification...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/agent-abidjan-login" replace />;
  }

  return children;
}

export default ProtectedAgentRoute;